import { useQuery } from '@tanstack/react-query';

import { PROJECT_BASE_URL } from '@/src/components/project/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from './config';

const url = `${PROJECT_BASE_URL}/compose-email-from-options`;

type EmailFromOptionsResponse = {
  projectEmail: string;
  workstreamEmails: string[];
};

export const getEmailFromOptions = (projectId: string): Promise<EmailFromOptionsResponse> => {
  return axios.get(generateRoutePath(url, { projectId }));
};

export const emailFromOptionsKeys = {
  all: ['emailFromOptions'] as const,
  list: (projectId: string) => [INBOX_API_KEY, ...emailFromOptionsKeys.all, projectId] as const,
};

type QueryFnType = typeof getEmailFromOptions;

type useEmailFromOptionsOptions = {
  projectId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetEmailFromOptions = ({ projectId, config }: useEmailFromOptionsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailFromOptionsKeys.all, projectId],
    queryFn: () => getEmailFromOptions(projectId),
    staleTime: Infinity,
    ...config,
  });
};
